let map;
const markers = window.mapSettings.markers;

function initMap() {
  if (markers.length) {
    map = new google.maps.Map(document.getElementById("storageMap"));
    window.eqfeed_callback = eqfeed_callback();
    window.daMap = map;
  }
}

const eqfeed_callback = function () {
  let bounds = new google.maps.LatLngBounds();

  for (let i = 0; i < markers.length; i++) {
    const place = markers[i];
    const latLng = new google.maps.LatLng(place.lat, place.lng);
    const infoWindow = new google.maps.InfoWindow();
    let marker = new google.maps.Marker({
      position: latLng,
      map: map,
      label: "" + (i+1),
      title: place.name,
    });
    infoWindow.setContent(
      `<a href="${place.link}"><b>${place.name}</b></a> <br/> ${place.address} <br/> ${place.city}, ${place.state} ${place.postal_code}`
    );

    marker.addListener("click", () => {
      infoWindow.open({
        anchor: marker,
        map,
        shouldFocus: false,
      });
    });
    bounds.extend(marker.getPosition());
  }

  let initialZoom = true;
  google.maps.event.addListener(map, 'zoom_changed', () => {
    const zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', () => {
        google.maps.event.removeListener(zoomChangeBoundsListener);
        if (map.getZoom() > 12 && initialZoom === true) {
          map.setZoom(12);
          initialZoom = false;
        }
      });
  });
  map.fitBounds(bounds);
};

try {
  window.initMap = initMap();
} catch (error) {
  setTimeout(() => {
    window.initMap = initMap();
  }, 500);
}

$("[ref=phone-number]").on("click", async function () {
  await axios.post("/helper/track/phone/" + $(this).prop("id"));
});
